import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { baseURL } from "../../Config";
import { EDIT_DOCTOR_PROFILE, PAYER_LIST_WITHOUT_MIDDLEWARE_API, PROFILE_API, SPECIALTY_LIST_WITHOUT_PAGINATION } from "../../Helper/ApiPath";
import {
    ASSIGN_DOCTOR,
    BIRTH_DATE,
    CANCEL,
    CHOOSE_DOCTOR_TYPE,
    DOCTOR_SPECIALTY,
    EDIT_DOCTOR_DETAILS,
    EDIT_PROFILE,
    FIRST_NAME,
    GENDER,
    HOME,
    LAST_NAME,
    LICENSE_NUMBER,
    NPI1,
    NPI2,
    PAYER,
    PHONE_LENGTH,
    PHONE_NO,
    PTAN_NUMBER,
    SELECT_GENDER,
    SELECT_PAYER,
    SSN,
    TAXID,
    UPDATE,
} from "../../Helper/Constants";
import { dateAPIFormate, dateFormateMonthDateYear, minYear } from "../../Helper/Helper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    DOCTOR_ID_NOT_FOUND,
    ENTER_FNAME,
    ENTER_LNAME,
    ENTER_NPI1,
    ENTER_NPI_LESS_THAN_10,
    ENTER_PAYER,
    ENTER_PTAN_LESS_THAN_10,
    ENTER_SPECIALTY,
    ENTER_SSN_LESS_THAN_10,
    ENTER_TAX_ID_LESS_THAN_10,
    MAX_LENGTH,
    PHONE_NUMBER,
} from "../../Helper/Messages";
import Select from "react-select";

function DoctorEditDoctor() {
    const [isLoading, setIsLoading] = useState(false);
    let doctorId = localStorage.getItem("doctorDoctorId");
    let logToken = JSON.parse(localStorage.getItem("logToken")).token;
    let navigate = useNavigate();

    const [doctorInfo, setDoctorInfo] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        phoneNo1: "",
        gender: "",
        dob: "",
        npi1: "",
        npi2: "",
        ssn: "",
        taxId: "",
        licenseNumber: "",
        speciality: "",
        ptanNumber: "",
        fee: "",
        profilePic: "",
        payerName: "",
        payerId: "",
    });
    const [payer, setPayer] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "ssn" || name === "taxId" || name === "npi1" || name === "npi2") {
            const onlyNumber = e.target.value.replace(/[^0-9,-]/g, "");
            setDoctorInfo({ ...doctorInfo, [name]: onlyNumber });
        } else {
            setDoctorInfo({ ...doctorInfo, [name]: value });
        }
    };

    const fetchData = async () => {
        await axios
            .get(`${baseURL}/${PROFILE_API}/${doctorId}`, {
                headers: { authorization: logToken, "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                setDoctorInfo(res.data.data);
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };
    const handlePayerChange = (e) => {
        let label = e.label;
        let value = e.id;
        setDoctorInfo({ ...doctorInfo, payerName: label, payerId: value });
    };
    const payerList = () => {
        axios
            .get(`${baseURL}/${PAYER_LIST_WITHOUT_MIDDLEWARE_API}`)
            .then((res) => {
                setPayer(res.data.data);
            })
            .catch((err) => {
                if (err.response) {
                    if (err.response.status == 500) {
                        localStorage.clear();
                        navigate("/login");
                    } else {
                        toast.error(err.response.data.message);
                    }
                }
            });
    };
    const payerOptions =
        payer &&
        payer.map((item, i) => {
            return {
                id: item.id,
                value: item.value,
                label: item.name,
            };
        });
        
    const [specialtyList, setSpecialtyList] = useState([]);

    const specialtyData = async () => {
        await axios
            .post(`${baseURL}/${SPECIALTY_LIST_WITHOUT_PAGINATION}`)
            .then((res) => {
                setSpecialtyList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    
    const specialtyOptions =
        specialtyList &&
        specialtyList.map((item, i) => {
            return {
                id: item.id,
                value: item.id,
                label: item.name,
            };
        });

    const handleSpecialtyChange = (e) => {
        setDoctorInfo({ ...doctorInfo, speciality: e.value });
    };
    
    const handleUpdate = async () => {
        if (!doctorId) {
            toast.error(DOCTOR_ID_NOT_FOUND);
        } else if (!doctorInfo.firstName) {
            toast.error(ENTER_FNAME);
        } else if (!doctorInfo.lastName) {
            toast.error(ENTER_LNAME);
        } else if (!doctorInfo.npi1) {
            toast.error(ENTER_NPI1);
        } else if (doctorInfo.npi1 && doctorInfo.npi1.length > MAX_LENGTH) {
            toast.error(ENTER_NPI_LESS_THAN_10);
        } else if (doctorInfo.npi2 && doctorInfo.npi2.length > MAX_LENGTH) {
            toast.error(ENTER_NPI_LESS_THAN_10);
        } else if (doctorInfo.ssn && doctorInfo.ssn.length > MAX_LENGTH) {
            toast.error(ENTER_SSN_LESS_THAN_10);
        } else if (doctorInfo.taxId && doctorInfo.taxId.length > MAX_LENGTH) {
            toast.error(ENTER_TAX_ID_LESS_THAN_10);
        } else if (doctorInfo.ptanNumber && doctorInfo.ptanNumber.length > MAX_LENGTH) {
            toast.error(ENTER_PTAN_LESS_THAN_10);
        } else if (!doctorInfo.speciality) {
            toast.error(ENTER_SPECIALTY);
        } else if (!doctorInfo.payerId) {
            toast.error(ENTER_PAYER);
        } else if (doctorInfo.phoneNo1 && doctorInfo.phoneNo1.length > PHONE_LENGTH) {
            toast.error(PHONE_NUMBER);
        } else {
            setIsLoading(true);
            await axios
                .post(`${baseURL}/${EDIT_DOCTOR_PROFILE}`, {
                    headers: { authorization: logToken, "Content-Type": "multipart/form-data" },
                    firstName: doctorInfo.firstName,
                    middleName: doctorInfo.middleName,
                    lastName: doctorInfo.lastName,
                    phoneNo1: doctorInfo.phoneNo1,
                    dob: dateAPIFormate(doctorInfo.dob),
                    npi1: doctorInfo.npi1,
                    npi2: doctorInfo.npi2,
                    ssn: doctorInfo.ssn,
                    taxId: doctorInfo.taxId,
                    licenseNumber: doctorInfo.licenseNumber,
                    gender: doctorInfo.gender,
                    speciality: doctorInfo.speciality,
                    ptanNumber: doctorInfo.ptanNumber,
                    doctorId: doctorId,
                    payerId: doctorInfo.payerId,
                })
                .then((res) => {
                    setIsLoading(false);
                    if (res.status === 200) {
                        toast.success(res.data.message);
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    if (err.response) {
                        if (err.response.status == 500) {
                            localStorage.clear();
                            navigate("/login");
                        } else {
                            toast.error(err.response.data.message);
                        }
                    }
                });
        }
    };

    const handleCancel = () => {
        navigate("/assignDoctor");
    };
    useEffect(() => {
        fetchData();
        payerList();
        specialtyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className="pull-left">
                                <div className="page-title">{EDIT_DOCTOR_DETAILS}</div>
                            </div>
                            <ol className="breadcrumb page-breadcrumb pull-right">
                                <li>
                                    <i className="fa fa-home"></i>&nbsp;
                                    <NavLink className="parent-item" to="/dashboard">
                                        {HOME}
                                    </NavLink>
                                    &nbsp;<i className="fa fa-angle-right"></i>
                                </li>
                                <li>
                                    <i className="fa fa-user-md"></i>&nbsp;
                                    <NavLink className="parent-item" to="/assignDoctor">
                                        {ASSIGN_DOCTOR}
                                    </NavLink>
                                    &nbsp;<i className="fa fa-angle-right"></i>
                                </li>
                                <li className="active">{EDIT_PROFILE}</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>{EDIT_DOCTOR_DETAILS}</header>
                                </div>
                                <div className="card-body" id="bar-parent">
                                    <form action="#" id="form_sample_1" className="form-horizontal">
                                        <div className="form-body">
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">
                                                    {FIRST_NAME}
                                                    <span className="required"> * </span>
                                                </label>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        name="firstName"
                                                        placeholder=" Enter first name"
                                                        value={doctorInfo.firstName}
                                                        onChange={handleChange}
                                                        className="form-control input-height"
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="control-label col-md-3">
                                                    {LAST_NAME}
                                                    <span className="required"> * </span>
                                                </label>
                                                <div className="col-md-5">
                                                    <input
                                                        type="text"
                                                        name="lastName"
                                                        placeholder=" Enter last name"
                                                        value={doctorInfo.lastName}
                                                        onChange={handleChange}
                                                        className="form-control input-height"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{BIRTH_DATE}</label>
                                                <div className="col-md-5">
                                                    <div className="input-append date">
                                                        <div id="dateIcon2" className="input-group datePicker">
                                                            <DatePicker
                                                                className="form-control mr-sm-2"
                                                                maxDate={new Date(minYear)}
                                                                scrollableMonthDropdown={true}
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                value={dateFormateMonthDateYear(doctorInfo && doctorInfo.dob)}
                                                                onChange={(date) => setDoctorInfo({ ...doctorInfo, dob: date })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{GENDER}</label>
                                                <div className="col-md-5">
                                                    <select className="form-control input-height" name="gender" value={doctorInfo.gender} onChange={handleChange}>
                                                        <option value=""> {SELECT_GENDER}</option>
                                                        <option value="male">Male</option>
                                                        <option value="female">Female</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{PHONE_NO}</label>
                                                <div className="col-md-5">
                                                    <input
                                                        name="phoneNo1"
                                                        type="number"
                                                        placeholder="mobile number"
                                                        onChange={handleChange}
                                                        value={doctorInfo.phoneNo1}
                                                        className="form-control input-height"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">
                                                    {NPI1}
                                                    <span className="required"> * </span>
                                                </label>
                                                <div className="col-md-5">
                                                    <input name="npi1" type="text" placeholder="NPI number" onChange={handleChange} value={doctorInfo.npi1} className="form-control input-height" />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{NPI2}</label>
                                                <div className="col-md-5">
                                                    <input name="npi2" type="text" placeholder="NPI number" onChange={handleChange} value={doctorInfo.npi2} className="form-control input-height" />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{SSN}</label>
                                                <div className="col-md-5">
                                                    <input name="ssn" type="text" placeholder="SSN number" onChange={handleChange} value={doctorInfo.ssn} className="form-control input-height" />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{TAXID}</label>
                                                <div className="col-md-5">
                                                    <input name="taxId" type="text" placeholder="TaxId number" onChange={handleChange} value={doctorInfo.taxId} className="form-control input-height" />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{LICENSE_NUMBER}</label>
                                                <div className="col-md-5">
                                                    <input
                                                        name="licenseNumber"
                                                        type="text"
                                                        placeholder="License Number "
                                                        onChange={handleChange}
                                                        value={doctorInfo.licenseNumber}
                                                        className="form-control input-height"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">{PTAN_NUMBER}</label>
                                                <div className="col-md-5">
                                                    <input
                                                        name="ptanNumber"
                                                        type="text"
                                                        placeholder="PTAN Number"
                                                        onChange={handleChange}
                                                        value={doctorInfo.ptanNumber}
                                                        className="form-control input-height"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">
                                                    {DOCTOR_SPECIALTY}
                                                    <span className="required"> * </span>
                                                </label>
                                                <div className="col-md-5">
                                                    <Select
                                                        menuPlacement="top"
                                                        name="specialty"
                                                        value={specialtyOptions && specialtyOptions.filter(({ value }) => value == doctorInfo.speciality)}
                                                        options={specialtyOptions}
                                                        onChange={handleSpecialtyChange}
                                                    />
                                                    {/* <select className="form-control input-height" name="speciality" onChange={handleChange} value={doctorInfo.speciality}>
                                                        {Object.keys(CHOOSE_DOCTOR_TYPE).map((item, i) => {
                                                            return (
                                                                <option key={i} value={CHOOSE_DOCTOR_TYPE[item]}>
                                                                    {item}
                                                                </option>
                                                            );
                                                        })}
                                                    </select> */}
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3">
                                                    {PAYER}
                                                    <span className="required"> * </span>
                                                </label>
                                                <div className="col-md-5">
                                                    <Select
                                                        menuPlacement="top"
                                                        className="text-dark"
                                                        name="payerId"
                                                        value={payerOptions && payerOptions.filter(({ id }) => id === doctorInfo.payerId)}
                                                        options={payerOptions}
                                                        onChange={handlePayerChange}
                                                        placeholder={SELECT_PAYER}
                                                    ></Select>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <label className="control-label col-md-3"></label>
                                                <div className="col-md-5">
                                                    {isLoading ? (
                                                        <>
                                                            <button type="button" className="btn btn-primary m-r-20" disabled>
                                                                {UPDATE}
                                                            </button>
                                                            <i className="fa fa-spinner fa-spin fa-2x loaderUpdateBtnSpinner"></i>
                                                        </>
                                                    ) : (
                                                        <button type="button" className="btn btn-primary m-r-20" onClick={handleUpdate}>
                                                            {UPDATE}
                                                        </button>
                                                    )}
                                                    <button type="button" className="btn btn-default m-r-20" onClick={handleCancel}>
                                                        {CANCEL}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DoctorEditDoctor;
